import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import styled from 'styled-components';

import { ActivityIndicator, LoaderCover } from './';
import { ParallaxElement } from '../../parallax/components';

const Wrapper = styled(ParallaxElement)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  margin: inherit;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
    //height: auto;
  }
`;

const Fade = ({ children, ...props }) => (
  <CSSTransition {...props} timeout={500} classNames="fade">
    {children}
  </CSSTransition>
);

class PreloadVideo extends Component {
  static propTypes = {
    circular: PropTypes.bool,
    src: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      inView: false,
      loading: true,
      error: false,
      shouldLoad: false,
      loaderExited: false,
    };
  }

  componentWillUnmount = () => {
    if (this.video) {
      this.video.removeEventListener('canplaythrough', this.onLoad);
      this.video.removeEventListener('load', this.onLoad);
    }
  };

  loadVideo = () => {
    this.video.addEventListener('canplaythrough', this.onLoad);
    this.video.addEventListener('load', this.onLoad);
    this.setState({
      shouldLoad: true,
    });
  };

  onError = () => {
    this.setState({
      loading: false,
      error: true,
    });
  };

  onLoad = e => {
    requestAnimationFrame(() => {
      this.setState({
        loading: false,
        error: false,
      });
      this.video.removeEventListener('canplaythrough', this.onLoad);
      this.video.removeEventListener('load', this.onLoad);
      if (this.state.inView) {
        try {
          this.video.play();
        } catch (e) {}
      }
    });
  };

  inViewCallback = inView => {
    const oldState = this.state.inView;
    if (inView === oldState) return;
    this.setState({
      inView,
    });
    if (inView && this.state.loading) {
      this.loadVideo();
    } else {
      if (!this.state.loading) {
        try {
          inView ? this.video.play() : this.video.pause();
        } catch (e) {}
      }
    }
  };

  onLoaderExited = () => {
    this.setState({
      loaderExited: true,
    });
  };

  boundRef = el => {
    this.video = el;
  };

  render() {
    const { circular } = this.props;
    const className = classnames({
      circular,
    });
    const { loaderExited, loading, shouldLoad } = this.state;
    const { src } = this.props;
    return (
      <Wrapper
        className={className}
        inViewCallback={this.inViewCallback}
        inViewOnce={false}
      >
        <video
          muted
          autoPlay={shouldLoad}
          preload={shouldLoad ? 'auto' : 'none'}
          loop
          ref={this.boundRef}
        >
          {shouldLoad && <source src={src} type="video/mp4" />}
        </video>
        <Fade in={loading} onExited={this.onLoaderExited}>
          <LoaderCover loading={loading} className={loaderExited && 'exited'} />
        </Fade>
        <Fade in={loading} onExited={this.onLoaderExited}>
          <ActivityIndicator
            loading={loading}
            className={loaderExited && 'exited'}
          />
        </Fade>
      </Wrapper>
    );
  }
}

export default PreloadVideo;



// WEBPACK FOOTER //
// ./src/modules/pages/components/PreloadVideo.js